import React, { Component } from "react";

export default class UnavailableListItem extends Component {
  getPictureUrl = url => {
    let replacedWidth = (url && url.replace("[WIDTH]", "160")) || "";
    const newUrl =
      (replacedWidth && replacedWidth.replace("[HEIGHT]", "160")) || "";
    return newUrl;
  };
  handleClickFavorite = (slugName, postalCode, adminWard, city) => {
    let href;
    const localdata =
      (localStorage.getItem("deliveryDetails") &&
        JSON.parse(localStorage.getItem("deliveryDetails"))) ||
      null;
    let preOrder;
    if (localdata) {
      preOrder = localdata.preOrder || "";
    }
    href = href = `/restaurant/${city}/${adminWard}/${slugName}/?postcode=${postalCode}&time=${(preOrder &&
      preOrder) ||
      "now"}`;
    if (href) {
      window.location.href = href;
    }
  };
  render() {
    const {
      item,
      edit,
      handleSelectItem,
      selectedItems,
      handleRemove
    } = this.props;

    const isChecked =
      (selectedItems.find(selectedItem => selectedItem === item.uid) &&
        "checked") ||
      "";
    const pictureUrl = item && item.picture && item.picture.url;
    const avgClassName = `avg-score s${parseInt(item.avgScore)}`;
    return (
      <div className="d-flex justify-content-between align-items-center">
        <div
          className="d-flex cursor-pointer"
          onClick={() =>
            this.handleClickFavorite(
              item.slugName,
              item.restaurantAddressPostalCode,
              item.restaurantAddressSlugAdminWard,
              item.restaurantAddressSlugCityName
            )
          }
        >
          <div className="img">
            <img src={this.getPictureUrl(pictureUrl)} />
            {(item.avgScore && (
              <span className={avgClassName}>
                {parseFloat(item.avgScore).toFixed(1)}
              </span>
            )) || <noscript />}
          </div>

          <div className="desc">
            <h4>{item.name}</h4>
            {(item.types &&
              item.types.length &&
              item.types.map((type, i) => (
                <p key={i}>
                  {(item.types.length !== i + 1 && type.name + ", ") ||
                    type.name}
                </p>
              ))) || <noscript />}
            {(item.minOrderAmount && (
              <div>
                <p>
                  Min. £{parseFloat(item.minOrderAmount).toFixed(2)} / Free
                  Delivery{" "}
                  {(item.deliveryFee.amount &&
                    `after ${parseFloat(
                      item.deliveryFee.freeDeliveryMoreThanAmount
                    ).toFixed(2)}`) ||
                    ""}
                </p>
              </div>
            )) || <noscript />}
            {(item.reOpenDate && <div>Opens on {item.reOpenDate}</div>) || (
              <noscript />
            )}
          </div>
        </div>
        <div className="hide-xs">
          <a
            onClick={e => handleRemove(e, item.uid)}
            href="javascript:void(0)"
            className="scaleHover"
          >
            <i className="icon icon-trash" />
          </a>
        </div>
        <div className="check visible-xs">
          {(edit && (
            <React.Fragment>
              <label htmlFor={item.uid}>
                <input
                  type="checkbox"
                  name={item.uid}
                  checked={isChecked}
                  id={item.uid}
                  onClick={handleSelectItem}
                />
                <span className="checkmark" />
              </label>
            </React.Fragment>
          )) || <noscript />}
        </div>
      </div>
    );
  }
}
